/**
 * defa.views.UserThankYouView
 * A view for thanking the user for his patronage.
 * !TODO: Can this view be replaced with a successView or a similar view from the defa/basic package?
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/userThankYouView.jst.html';

const UserThankYouView = View.extend( {
	
	template: template,
	
	templateContext: function () {
		return {
			message: this.model.get( 'message' ),
		};
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UserThankYouView;